import React from 'react';
import { shallowEqual, useSelector } from 'umi';
import { mobilePageConfig } from './mobilePageConfig';
import { pcPageConfig } from './pcPageConfig';
import { nightgalePageConfig } from './nightgalePageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';

const reqParams = '/engagement/return';
const Return = () => {
  const dataFrame = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile'
  },shallowEqual);
  const pageMap: any = {
    mobile: mobilePageConfig,
    pc: pcPageConfig,
    pc_inflexion: nightgalePageConfig,
  }
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame]} />
    </>
  );
};

export default Return;